<template>
	<div class="userInfoContainer">
		<div class="userInfoItem">
			<div class="itemTitle">
				头像/昵称
			</div>
			<div class="itemContent">
				<div class="avatarNameSaveBox">
					<div class="avatarNameBox">
						<div class="avatarBox" @click="uploadPhoto">
							<img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
							<img class="avatar" src="../../assets/defaultAvatar.png" v-else />
							<img class="editIcon" src="../../assets/Personal/iconA.png" />
						</div>
						<div class="nameBox">
							{{userInfo.user_nickname ? userInfo.user_nickname : ''}}
							<div class="editName" @click="ruleForm.user_nickname = userInfo.user_nickname;show = true">
								修改</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				基本信息
			</div>
			<div class="itemContent">
				<div class="phoneEmailSettingBox">
					<!-- <div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							昵称:
							<span>{{userInfo.user_nickname ? userInfo.user_nickname : ''}}</span>
						</div>
						<div class="edit" @click="ruleForm.user_nickname = userInfo.user_nickname;show = true">修改</div>
					</div> -->
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							姓名:
							<span>{{userInfo.hs_name ? userInfo.hs_name : ''}}</span>
						</div>
					</div>
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							身份证号:
							<span>{{userInfo.sfz ? userInfo.sfz : ''}}</span>
						</div>
					</div>
				</div>
				<div class="phoneEmailSettingBox">
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							手机号:
							<span>{{userInfo.mobile ? hideMiddleDigits(userInfo.mobile) : ''}}</span>
						</div>
						<div class="edit" @click="phoneShow = true">修改</div>
					</div>
					<div class="phoneEmailSettingItem">
						<div class="phoneEmailSettingItemContent">
							邮箱:
							<span>{{userInfo.user_email ? userInfo.user_email : ''}}</span>
						</div>
						<div class="edit" @click="ruleForm.user_email = userInfo.user_email;emailShow = true">修改</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				画师简介
				<div class="edit" @click="dialogInfoViable = true">修改</div>
			</div>
			<div class="itemContent">
				<div class="descBox">
					<div class="descItem">
						<span class="descTitle">在线时间：</span>
						<div v-html="userInfo.hs_time ? userInfo.hs_time.replace(/\n/g, '<br/>'): ''">
						</div>
					</div>
					<div class="descItem">
						<span class="descTitle">偏好类型：</span>
						<div v-html="userInfo.hs_ph ? userInfo.hs_ph.replace(/\n/g, '<br/>'): ''">
						</div>
					</div>
					<div class="descItem">
						<span class="descTitle">不接类型：</span>
						<div v-html="userInfo.hs_bj ? userInfo.hs_bj.replace(/\n/g, '<br/>'): ''">
						</div>
					</div>
					<div class="descItem">
						<span class="descTitle">约稿须知：</span>
						<div v-html="userInfo.hs_yg ? userInfo.hs_yg.replace(/\n/g, '<br/>'): ''">
						</div>
					</div>
					<div class="descItem">
						<span class="descTitle">定制须知：</span>
						<div v-html="userInfo.hs_dj ? userInfo.hs_dj.replace(/\n/g, '<br/>'): ''">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				密码修改
			</div>
			<div class="itemContent">
				<el-form ref="pwdRuleForm" class="register-form" inline hide-required-asterisk :model="ruleForm"
					:rules="rules">
					<el-form-item label="旧密码：" prop="old_pwd">
						<div class="invite-container">
							<input :type="showOldPwd ? 'text' : 'password'" v-model="ruleForm.old_pwd"
								placeholder="请输入旧密码" class="invite-input" />
							<img class="showPwd" src="../../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
								v-if="!showOldPwd" />
							<img class="showPwd" src="../../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
								v-else />
							<span class="error-message" v-if="pwdErrorShow">密码错误</span>
						</div>
					</el-form-item>
					<el-form-item label="新密码：" prop="new_pwd">
						<div class="invite-container">
							<input :type="showNewPwd ? 'text' : 'password'" v-model="ruleForm.new_pwd"
								placeholder="请输入新密码" class="invite-input" />
							<img class="showPwd" src="../../assets/Personal/iconP.png" @click="showNewPwd = !showNewPwd"
								v-if="!showNewPwd" />
							<img class="showPwd" src="../../assets/Personal/iconO.png" @click="showNewPwd = !showNewPwd"
								v-else />
						</div>
					</el-form-item>
					<button type="button" class="save-btn" @click="submitPwdForm('pwdRuleForm')">保存</button>
				</el-form>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				收款账户
				<div class="edit" @click="dialogBankViable = true">修改</div>
			</div>
			<div class="itemContent">
				<div class="descBox">
					<div class="descItem">
						<span class="descTitle">
							真实姓名：
						</span>
						{{userInfo.sk_name ? userInfo.sk_name : ''}}
					</div>
					<div class="descItem">
						<span class="descTitle">
							银行卡号：
						</span>
						{{userInfo.sk_num ? userInfo.sk_num : ''}}
					</div>
					<div class="descItem">
						<span class="descTitle">
							开户行：
						</span>
						{{userInfo.sk_bank ? userInfo.sk_bank : ''}}
					</div>
				</div>
			</div>
		</div>
		<el-upload ref="upload" name="image" style="font-size: 0;"
			action="https://ht.daiyuart.com/api.php/set/Other/upload_img" :show-file-list="false"
			:on-success="handlePhotoSuccess">
		</el-upload>
		<el-dialog class="reportDialog" :visible="show" append-to-body @close="show = false">
			<div slot="title">
				<div class="dislogTitle">
					昵称修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="user_nickname">
						<el-input v-model="ruleForm.user_nickname" placeholder="请输入昵称" />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="reportDialog" :visible="emailShow" append-to-body @close="emailShow = false">
			<div slot="title">
				<div class="dislogTitle">
					邮箱修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="user_email">
						<el-input v-model="ruleForm.user_email" placeholder="请输入邮箱" />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitEmailForm('ruleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="likeSetDialog" :visible="likeSetShow" append-to-body @close="likeSetShow = false">
			<div slot="title">
				<div class="dislogTitle">
					请选择您喜欢的标签，平台推荐更精准哦!
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="likeRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="cate">
						<div class="cateBoxTitle">
							图片分类
						</div>
						<div class="cateList">
							<div class="cateItem"
								:class="{'active': ruleForm.cate.findIndex(row => row == item.id) > -1}"
								v-for="(item,index) in typeOpts" :key="index" @click="addCate(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="purpose">
						<div class="cateBoxTitle">
							图片用途
						</div>
						<div class="cateList">
							<div class="cateItem"
								:class="{'active': ruleForm.purpose.findIndex(row => row == item.id)>-1}"
								v-for="(item,index) in yongtuOpts" :key="index" @click="addPurpose(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitLikeForm('likeRuleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="phoneDialog" :visible="phoneShow" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					手机号修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="phone">
						<div class="form-group" style="width: 3.85rem;">
							<div class="verification-container">
								<input type="email" v-model="ruleForm.phone" placeholder="请输入原手机号码"
									class="phone-input" />
								<span v-if="showPhoneError" class="error-message">原手机号错误</span>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="new_phone">
						<div class="form-group" style="width: 3.85rem;">
							<div class="phone-input-container">
								<input type="tel" v-model="ruleForm.new_phone" placeholder="请输入新手机号码"
									class="phone-input" />
								<span class="error-message" v-if="showNewPhoneError">手机号已存在</span>
								<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
									class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="" prop="code">
						<div class="form-group" style="width: 3.85rem;">
							<div class="verification-container">
								<input type="text" v-model="ruleForm.code" placeholder="请输入验证码"
									class="verification-input" />
								<span v-if="showVerificationError" class="error-message">验证码错误</span>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitPhoneForm('phoneRuleForm')">提交</el-button>
				</div>
			</div>
		</el-dialog>

		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'修改成功！'" @clickOk="sucPop = false;"
			v-if="sucPop" />
		<BankInfoDialog :show="dialogBankViable" :data="userInfo" @close="dialogBankViable = false"
			@update="updateBank" />
		<PainterInfoDialog :show="dialogInfoViable" :data="userInfo" @close="dialogInfoViable = false"
			@update="updateInfo" />
	</div>
</template>

<script>
	import PopToast from '../../../src/components/PopToast.vue'
	import BankInfoDialog from '../../../src/components/BankInfoDialog.vue'
	import PainterInfoDialog from '../../../src/components/PainterInfoDialog.vue'
	export default {
		components: {
			PopToast,
			BankInfoDialog,
			PainterInfoDialog
		},
		data() {
			return {
				sucPop: false,
				dialogBankViable: false,
				dialogInfoViable: false,
				ruleForm: {
					user_nickname: '',
					new_pwd: '',
					old_pwd: '',
					user_email: '',
					cate: [],
					purpose: [],
				},
				rules: {
					user_nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					user_email: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					cate: [{
						required: true,
						message: '请至少选择一个分类',
						trigger: 'blur'
					}],
					purpose: [{
						required: true,
						message: '请至少选择一个用途',
						trigger: 'blur'
					}],
					new_pwd: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					old_pwd: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入原手机号码',
						trigger: 'blur'
					}],
					new_phone: [{
						required: true,
						message: '请输入新手机号码',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
				},
				showOldPwd: false,
				showNewPwd: false,
				countdown: 0,
				typeOpts: [],
				yongtuOpts: [],
				address: [],
				show: false,
				emailShow: false,
				phoneShow: false,
				pwdErrorShow: false,
				dialogAddressViable: false,
				showVerificationError: false,
				showNewPhoneError: false,
				showPhoneError: false,
				curAddress: {},
				userInfo: {},
				password: '',
				selAddressIndex: 0,
				likeSetShow: false,
				timer: null,
			}
		},
		mounted() {
			this.userDetails()
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			updateBank() {
				this.sucPop = true
				this.userDetails()
			},
			updateInfo() {
				this.sucPop = true
				this.userDetails()
			},
			addCate(item) {
				const index = this.ruleForm.cate.findIndex((row => row == item.id))
				if (index > -1) {
					this.ruleForm.cate.splice(index, 1)
				} else {
					this.ruleForm.cate.push(item.id)
				}
			},
			addPurpose(item) {
				const index = this.ruleForm.purpose.findIndex((row => row == item.id))
				if (index > -1) {
					this.ruleForm.purpose.splice(index, 1)
				} else {
					this.ruleForm.purpose.push(item.id)
				}
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						this.ruleForm.cate = res.data.image_fl ? res.data.image_fl.split(',') : []
						this.ruleForm.purpose = res.data.image_yt ? res.data.image_yt.split(',') : []
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userSave(key, value) {
				let params = {}
				params[key] = value
				this.$api.post('/UserD/user_save', params).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.userDetails()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.userSave('avatar', response.data)
			},
			hideMiddleDigits(phoneNumber) {
				if (typeof phoneNumber === 'string' && phoneNumber.length === 11) {
					// 将中间四位替换为星号
					return phoneNumber.slice(0, 3) + '****' + phoneNumber.slice(7);
				}
			},
			// 获取验证码
			getVerificationCode() {
				this.$refs.phoneRuleForm.validateField('new_phone', (valid) => {
					if (!valid) {
						this.$api.post('/Other/phone_code', {
							phone: this.ruleForm.new_phone,
						}).then(res => {
							if (res.code == 1) {
								this.countdown = 60;
								// 倒计时
								this.timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(this.timer);
									}
								}, 1000);
							} else {
								console.log(res.msg)
							}
							console.log(res)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return
					}
				});
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.showPhoneError = false
						this.showNewPhoneError = false
						this.showVerificationError = false
						if (this.ruleForm.phone != this.userInfo.mobile) {
							this.showPhoneError = true
							return
						}
						this.$api.post('/UserD/user_phone', {
							phone: this.ruleForm.phone,
							new_phone: this.ruleForm.new_phone,
							code: this.ruleForm.code,
						}).then(res => {
							if (res.code == 1) {
								this.userDetails()
								this.handleClose()
								this.$message.success(res.msg)
							} else {
								if (res.msg == '手机号已存在') {
									this.showNewPhoneError = true
								} else if (res.msg == '验证码错误') {
									this.showVerificationError = true
								}
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			handleClose() {
				if (this.timer) {
					clearInterval(this.timer);
				}
				this.phoneShow = false
				this.ruleForm.phone = ''
				this.ruleForm.new_phone = ''
				this.ruleForm.code = ''
				this.showPhoneError = false
				this.showNewPhoneError = false
				this.showVerificationError = false
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.userSave('user_nickname', this.ruleForm.user_nickname)
						this.show = false
					} else {
						return false
					}
				})
			},
			submitPwdForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/user_pwd', {
							new_pwd: this.ruleForm.new_pwd,
							old_pwd: this.ruleForm.old_pwd
						}).then(res => {
							if (res.code == 1) {
								this.showNewPwd = false
								this.showOldPwd = false
								this.ruleForm.new_pwd = ''
								this.ruleForm.old_pwd = ''
								this.pwdErrorShow = false
								this.$message.success(res.msg)
							} else {
								this.pwdErrorShow = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			submitEmailForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.userSave('user_email', this.ruleForm.user_email)
						this.emailShow = false
					} else {
						return false
					}
				})
			},
			submitLikeForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/UserD/user_save', {
							image_fl: this.ruleForm.cate.join(','),
							image_yt: this.ruleForm.purpose.join(',')
						}).then(res => {
							if (res.code == 1) {
								this.likeSetShow = false
								this.$message.success(res.msg)
								this.userDetails()
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.userInfoContainer {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: 0 .4rem .4rem;
	}

	.avatarNameSaveBox {
		margin-top: .16rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.avatarNameBox {
			display: flex;
			align-items: center;

			.avatarBox {
				display: flex;
				align-items: center;
				width: .7rem;
				height: .7rem;
				border-radius: 50%;
				overflow: hidden;
				position: relative;
				cursor: pointer;

				.avatar {
					width: .7rem;
					height: .7rem;
					object-fit: cover;
				}

				.editIcon {
					position: absolute;
					bottom: 0;
					left: .04rem;
					width: .6rem;
					height: .2rem;
				}
			}

			.nameBox {
				margin-left: .16rem;
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .18rem;
				color: #252525;

				.editName {
					margin-left: .08rem;
					width: .34rem;
					height: .2rem;
					background: rgba(226, 147, 88, .2);
					border-radius: .02rem;
					font-weight: 400;
					font-size: .12rem;
					color: #E29358;
					line-height: .2rem;
					text-align: center;
					cursor: pointer;
				}
			}
		}

		.save {
			width: .9rem;
			height: .36rem;
			background: #E29358;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .12rem;
			color: #252525;
			line-height: .36rem;
			text-align: center;
		}
	}

	.userInfoItem {
		display: flex;
		flex-direction: column;
		padding-bottom: .24rem;
		border-bottom: .01rem solid #CCCCCC;


		.itemTitle {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;

			.edit {
				margin-left: .08rem;
				width: .34rem;
				height: .2rem;
				background: rgba(226, 147, 88, .2);
				border-radius: .02rem;
				font-weight: 400;
				font-size: .12rem;
				color: #E29358;
				line-height: .2rem;
				text-align: center;
				cursor: pointer;
			}

			.addAddress {
				font-weight: 400;
				font-size: .12rem;
				color: #333333;
				cursor: pointer;
			}
		}

		.itemContent {
			display: flex;
			flex-direction: column;
			position: relative;

			.descBox {
				margin-top: .12rem;
				display: flex;
				flex-direction: column;

				.descItem {
					display: flex;
					align-items: flex-start;
					font-weight: 500;
					font-size: .16rem;
					color: #333333;
					line-height: .32rem;

					.descTitle {
						display: inline-block;
						width: .8rem;
						font-weight: 400;
					}
				}
			}

			.prev-btn,
			.next-btn {
				position: absolute;
				width: .12rem;
				height: .28rem;
				padding: 0 0;

				img {
					width: .12rem;
					height: .28rem;
				}
			}

			.prev-btn {
				top: calc(50% - .07rem);
				left: 0;
			}

			.next-btn {
				top: calc(50% - .07rem);
				right: 0;
			}

			.phoneEmailSettingBox {
				margin-top: .16rem;
				display: flex;
				align-items: center;

				.phoneEmailSettingItem {
					margin-right: .4rem;
					width: 2.72rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItemContent {
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;

						span {
							margin-left: .08rem;
							font-weight: 500;
							font-size: .18rem;
							color: #333333;
						}
					}

					.edit {
						margin-left: .08rem;
						width: .34rem;
						height: .2rem;
						background: rgba(226, 147, 88, .2);
						border-radius: .02rem;
						font-weight: 400;
						font-size: .12rem;
						color: #E29358;
						line-height: .2rem;
						text-align: center;
						cursor: pointer;
					}
				}
			}

			.register-form {
				margin-top: .16rem;
				display: flex;
				align-items: center;

				::v-deep .el-form-item {
					margin-bottom: 0;
					display: flex;
					align-items: center;

					&__label {
						font-size: 0.14rem;
						line-height: .4rem;
						padding: 0 .12rem 0 0;
					}


					&__error {
						font-size: .12rem;
						padding-top: .04rem;
					}
				}

				.form-group {
					margin-top: .16rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
				}

				.invite-container {
					width: 3rem;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
					position: relative;

					.showPwd {
						position: absolute;
						top: calc(50% - .12rem);
						right: .1rem;
						width: .24rem;
						height: .24rem;
						cursor: pointer;
					}
				}

				.invite-input {
					width: 1.8rem;
					height: 0.4rem;
					border: none;
					outline: none;
					padding: 0 0;

					font-size: 0.14rem;
					color: #333333;

					&::placeholder {
						color: #999999;
					}
				}

				.save-btn {
					margin-left: .38rem;
					width: 1.22rem;
					height: .36rem;
					background: #E29358;
					border-radius: .04rem;
					font-weight: 500;
					font-size: .12rem;
					color: #252525;
					line-height: .36rem;
					text-align: center;
					padding: 0 0;

				}

				// 错误提示样式
				.error-message {
					margin-right: .2rem;
					background: #F56C6C;
					padding: 0.04rem 0.09rem;
					border-radius: 0.02rem;
					font-weight: 400;
					font-size: 0.12rem;
					color: #FFFFFF;
					line-height: .18rem;
				}
			}

			.addressList {
				margin-top: .24rem;
				border-left: .14rem solid #FFFFFF;
				border-right: .14rem solid #FFFFFF;
				width: 100%;
				display: flex;
				white-space: nowrap;
				overflow-x: auto;

				.active {
					border: .01rem solid #E29358;
				}

				.normal {
					border: .01rem solid #CCCCCC;
				}

				.addressItem {
					flex-shrink: 0;
					margin-right: .16rem;
					width: 2.72rem;
					height: .95rem;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: .16rem .16rem;
					border-radius: .08rem;
					cursor: pointer;
					position: relative;

					.editMenu {
						position: absolute;
						bottom: .2rem;
						right: .12rem;
						display: flex;
						align-items: center;

						.editIcon {
							margin-left: .08rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.province {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}

					.address {
						font-weight: 500;
						font-size: .14rem;
						color: #1C1C1C;
					}

					.namePhone {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}
				}
			}

			.addressList::-webkit-scrollbar {
				width: 0;
				height: 0;
			}

			/* Firefox */
			.addressList {
				scrollbar-width: none;
				/* Firefox 隐藏滚动条 */
			}

			/* IE / Edge 老版本 */
			.addressList {
				-ms-overflow-style: none;
				/* IE11, Edge */
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.likeSetDialog {
		::v-deep .el-dialog {
			width: 10.48rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.cateBoxTitle {
		font-weight: 400;
		font-size: .16rem;
		color: #333333;
		line-height: .22rem;
	}

	.cateList {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.cateItem {
			margin-top: .24rem;
			margin-right: .32rem;
			width: 1.28rem;
			height: .48rem;
			font-weight: 400;
			font-size: .16rem;
			color: #666666;
			border-radius: .04rem;
			border: .01rem solid #CCCCCC;
			line-height: .48rem;
			text-align: center;
			cursor: pointer;

			// &:hover {
			// 	color: #E29358;
			// 	border-color: #E29358;
			// }

			&.active {
				color: #E29358;
				border-color: #E29358;
			}
		}
	}


	.phoneDialog {
		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.form-group {
					// margin-top: .16rem;
				}

				.form-input {
					width: 100%;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					transition: border-color 0.3s ease;

					// &:focus {
					// 	border-color: #E29358;
					// }

					&::placeholder {
						color: #999999;
					}
				}

				// 手机号和验证码输入框样式
				.phone-input-container,
				.verification-container,
				.invite-container {
					width: 100%;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.phone-input,
				.verification-input,
				.invite-input {
					height: 0.4rem;
					width: 1.8rem;
					border: none;
					outline: none;
					padding: 0 0;

					font-size: 0.14rem;
					color: #333333;

					&::placeholder {
						color: #999999;
					}
				}

				.get-code-btn {
					padding: 0 0;
					color: #E29358;
					font-size: 0.14rem;
					cursor: pointer;

					&:disabled {
						background: #FFFFFF;
						color: #CCCCCC;
						border-color: #CCCCCC;
						cursor: not-allowed;
					}
				}

				// 错误提示样式
				.error-message {
					background: #F56C6C;
					padding: 0.04rem 0.09rem;
					border-radius: 0.02rem;
					font-weight: 400;
					font-size: 0.12rem;
					color: #FFFFFF;
					line-height: .22rem;
				}


				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>